import { Breadcrumb } from 'antd'

export const BreadcrumbItem = Breadcrumb.Item
